import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <style />
    <g id="prefix__Layer_1">
      <linearGradient
        id="prefix__SVGID_1_"
        gradientUnits="userSpaceOnUse"
        x1={ 0 }
        y1={ 24 }
        x2={ 24 }
        y2={ 0 }
      >
        <stop offset={ 0 } stopColor="#f4cb29" />
        <stop offset={ 0.242 } stopColor="#e94a31" />
        <stop offset={ 0.274 } stopColor="#e04848" />
        <stop offset={ 0.337 } stopColor="#d24470" />
        <stop offset={ 0.386 } stopColor="#c94288" />
        <stop offset={ 0.417 } stopColor="#c64191" />
        <stop offset={ 0.719 } stopColor="#00a9bc" />
        <stop offset={ 0.768 } stopColor="#00a9b5" />
        <stop offset={ 0.841 } stopColor="#01a9a0" />
        <stop offset={ 0.928 } stopColor="#02a87f" />
        <stop offset={ 1 } stopColor="#03a85f" />
      </linearGradient>
      <path fill="url(#prefix__SVGID_1_)" d="M0 0h24v24H0z" />
    </g>
  </svg>
);

export default SvgComponent;
